/* eslint-disable */
/* global window */
const DEFAULT_EMULATE_TIMEOUT = 2000
const DEFAULT_EMULATE_DATA = {
  address: [{ address: 'tbnb12hlquylu78cjylk5zshxpdj6hf3t0tahwjt3ex' }],
  publicKey:
    '04e81c081b2879f63577d4e790838f57c217e7efe2fc14eb32f154eef1bd457224d60251d1d28bdbaaf943a478328cb148d49be5f6b87986030a4b52cb98b78109',
  signature:
    'd7367f30b85509eb59161171c9bdefa5fe241c254c3da07b189bbfdfeb204e2e12b72bdb594574202b6457b538c47653677cf61a732d39686bbb0f3d9f5405cb',
}

const WINDOW_INSTANCE_KEY = '_InfinitoBridgeInstance'

export class InfinitoWalletBridge {
  static CALL_GET_ADDRESS = 'getAddress'

  static CALL_GET_PUBLIC_KEY = 'getPublicKey'

  static CALL_SIGN_TRANSACTION = 'sign'

  static getInstance(...args) {
    window[WINDOW_INSTANCE_KEY] = window[WINDOW_INSTANCE_KEY] || new InfinitoWalletBridge(...args)
    return window[WINDOW_INSTANCE_KEY]
  }

  constructor(
    emulate = false,
    emulateData = DEFAULT_EMULATE_DATA,
    emulateWait = DEFAULT_EMULATE_TIMEOUT
  ) {
    this._init = false
    this._emulate = emulate
    this._emulateData = emulateData
    this._emulateWait = emulateWait
  }

  init = async () => {
    this._init = true
  }

  hasIntegration = () => this.hasInfinitoIntegration()

  hasInfinitoIntegration = () => {
    if (this._emulate === true) {
      return true
    }
    const expectedMethods = [
      InfinitoWalletBridge.CALL_GET_ADDRESS,
      InfinitoWalletBridge.CALL_GET_PUBLIC_KEY,
      InfinitoWalletBridge.CALL_SIGN_TRANSACTION,
    ]
    if (
      window &&
      window.infinitowallet &&
      window.infinitowallet.bnb &&
      expectedMethods.every(call => !!window.infinitowallet.bnb[call])
    ) {
      return true
    }
    return false
  }

  // async call (use `await`)
  getAddress = () =>
    new Promise((resolve, reject) => {
      if (this._emulate) {
        setTimeout(() => {
          const { address } = this._emulateData
          resolve({ address: address.address })
        }, this._emulateWait)
        return
      }
      if (!this.hasInfinitoIntegration()) {
        reject(new Error('Infinito Wallet was not found.'))
        return
      }
      window.infinitowallet.bnb[InfinitoWalletBridge.CALL_GET_ADDRESS]((err, result) => {
        if (err) {
          reject(err)
          return
        }
        // it's in an array!
        let address = result
        address = typeof address === 'string' ? address : address.address
        resolve({ address })
      })
    })

  // async call (use `await`)
  getPublicKey = () =>
    new Promise((resolve, reject) => {
      if (this._emulate) {
        setTimeout(() => {
          const { publicKey } = this._emulateData
          resolve({ publicKey })
        }, this._emulateWait)
        return
      }
      if (!this.hasInfinitoIntegration()) {
        reject(new Error('Infinito Wallet was not found.'))
        return
      }
      window.infinitowallet.bnb[InfinitoWalletBridge.CALL_GET_PUBLIC_KEY]((err, result) => {
        if (err || !result) {
          reject(err || new Error('No result from provider'))
          return
        }
        const { publicKey } = result
        resolve({ publicKey })
      })
    })

  // async call (use `await`)
  signTransaction = signDocObject =>
    new Promise((resolve, reject) => {
      if (this._emulate) {
        setTimeout(() => {
          const { signature } = this._emulateData
          resolve({ signature })
        }, this._emulateWait)
        return
      }
      if (!this.hasInfinitoIntegration()) {
        reject(new Error('Infinito Wallet was not found.'))
        return
      }
      const signDocPayload = { data: signDocObject }
      window.infinitowallet.bnb[InfinitoWalletBridge.CALL_SIGN_TRANSACTION](
        signDocPayload,
        (err, result) => {
          if (err || !result) {
            reject(err || new Error('No result from provider'))
            return
          }
          const { signature } = result
          resolve({ signature })
        }
      )
    })
}

export default {
  getInstance: (...args) => InfinitoWalletBridge.getInstance(...args),
}
